import { render, staticRenderFns } from "./VendorsView.vue?vue&type=template&id=e231f9a6"
import script from "./VendorsView.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorsView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports